export enum EmployeeStatus {
  Invited = 1,
  RequiresAction = 2,
  Ready = 3,
  Deployed = 4,
}
